<template>
    <div class="col-12">
        <div class="row">
            <div class="form-group col-11 col-md-12">
                <button type="button" class="col-12 col-md-auto btn btn-default"
                        @click="add">{{ $lang('Nowe kryterium') }}
                </button>
            </div>
        </div>
        <div class="row" v-if="criteria.length > 0">
            <table class="table simple-table table-striped table-sm">
                <thead>
                <tr>
                    <th scope="col">{{ $lang('Kryterium') }}</th>
                    <th scope="col">{{ $lang('Aktywne') }}</th>
                    <th scope="col">{{ $lang('Akcje') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="criterion in criteria">
                    <td :data-title="$lang('Kryterium')">{{ criterion.name }}</td>
                    <td :data-title="$lang('Aktywne')">
                        <span class="badge"
                              :class="{'badge-success': criterion.active, 'badge-danger': !criterion.active}">{{ criterion.active ? 'TAK' : 'NIE' }}</span>
                    </td>
                    <td :data-title="$lang('Akcje')">
                        <a class="mr-3" @click.prevent="getDetails(criterion)" href="#">{{ $lang('Szczegóły') }}</a>
                        <a class="mr-3" @click.prevent="edit(criterion)" href="#">{{ $lang('Edytuj') }}</a>
                        <a class="mr-3" @click.prevent="remove(criterion.id)" href="#">{{ $lang('Usuń') }}</a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="modal fade" id="modal_dict_criterion" tabindex="-1">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ modalNames[modalMode] }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="modalMode !== 'details'">
                            <div class="row">
                                <div class="col-lg-8 col-md-7 col-sm-12 col-12">
                                    <div class="form-group">
                                        <input class="form-control" id="new_criterion" placeholder="Nazwa"
                                               v-model="criterionEditable.name">
                                        <small class="text-red" v-if="error === true">
                                            {{ errorMessage }}</small>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-5 col-sm-12 col-12">
                                    <div class="form-check mb-2">
                                        <input type="checkbox" id="new_criterion_active" v-model="criterionEditable.active"
                                               class="form-check-input">
                                        <label for="new_criterion_active" class="form-check-label">
                                            {{ $lang('aktywny') }}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <vue-editor
                                            v-model="criterionEditable.description"
                                            :editor-toolbar="customToolbar"
                                            :placeholder="$lang('Definicja')">
                                        </vue-editor>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="row mb-1">
                                <div class="col-lg-2 col-md-3 col-sm-4 col-4">
                                    <span>{{ $lang('Nazwa:') }}</span>
                                </div>
                                <div class="col-lg-10 col-md-9 col-sm-8 col-8">
                                    <span v-if="criterionEditable.name !== ''">{{ criterionEditable.name }}</span>
                                    <span class="font-italic" v-else>{{ $lang('Brak') }}</span>
                                </div>
                            </div>
                            <div class="row mb-1">
                                <div class="col-lg-2 col-md-3 col-sm-4 col-4">
                                    <span><label for="criterion_active" class="mb-0">{{ $lang('Aktywna:') }}</label></span>
                                </div>
                                <div class="col-lg-10 col-md-9 col-sm-8 col-8">
                                    <input type="checkbox" id="criterion_active" v-model="criterionEditable.active" disabled>
                                </div>
                            </div>
                            <div class="row mb-1">
                                <div class="col-lg-2 col-md-3 col-sm-12 col-12">
                                    <span>{{ $lang('Definicja:') }}</span>
                                </div>
                                <div class="col-lg-10 col-md-9 col-sm-12 col-12">
                                    <span v-if="criterionEditable.description" v-html="criterionEditable.description"></span>
                                    <span class="font-italic" v-else>{{ $lang('Brak') }}</span>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">{{
                                $lang('Zamknij')
                            }}
                        </button>
                        <template v-if="modalMode !== 'details'">
                            <button id="criterion-new" v-if="modalMode === 'new'" @click.prevent="create()" type="button" class="btn btn-primary" :disabled="!newCriterionValid">
                                {{ $lang('Utwórz') }}
                            </button>
                            <button id="criterion-edit" v-else @click.prevent="update()" type="button" class="btn btn-primary" :disabled="!newCriterionValid">
                                {{ $lang('Zapisz') }}
                            </button>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ShowNotification from "../../mixins/show-notification";

export default {
    name: "dictionary-criterion",
    mixins: [ShowNotification],
    props: ['update_route', 'get_route', 'store_route', 'delete_route'],
    data() {
        return {
            criteria: [],
            error: false,
            errorMessage: '',
            criterionEditable: {
                id: null,
                name: '',
                active: false,
                description: null,
            },
            modalMode: 'add',
            modalNames: {
                new: this.$lang('Nowe kryterium'),
                edit: this.$lang('Edycja kryterium'),
                details: this.$lang('Szczegóły kryterium')
            },
            customToolbar: [
                [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                ["bold", "italic", "underline", "strike"],
                ["blockquote"],
                [{ list: "ordered" }, { list: "bullet" }, {list: "check" }],
                [{ indent: "-1" }, { indent: "+1" }],
                [{ color: [] }],
                ["clean"]
            ],
        }
    },
    methods: {
        get() {
            let self = this;
            axios.get(this.get_route, {})
                 .then(function (response) {
                     self.criteria = response.data;
                 })
                 .catch((error) => {
                 });
        },
        create() {
            let self = this;
            axios.post(this.store_route, this.criterionEditable)
                 .then(function (response) {
                     self.criteria = response.data;
                     $('#modal_dict_criterion').modal('hide');
                 })
                 .catch((error) => {
                     if (error.response.status === 422) {
                         self.error = true;
                         self.errorMessage = error.response.data;
                     }
                 });
        },
        update() {
            let self = this;
            axios.patch(this.update_route, this.criterionEditable)
                 .then(function (response) {
                     self.criteria = response.data;
                     $('#modal_dict_criterion').modal('hide');
                 })
                 .catch((error) => {
                     console.log(error);
                     if (error.response.status === 422) {
                         self.error = true;
                         self.errorMessage = error.response.data;
                     }
                 });
        },
        remove(id) {
            let self = this;
            axios.post(this.delete_route, {id: id})
                 .then(function (response) {
                     self.criteria = response.data;
                     self.showNotification('success', self.$lang('Moduł został usunięty!'));
                 })
                 .catch((error) => {
                     if (error.response.status === 422) {
                         this.showNotification('error', error.response.data.errors)
                     } else if (error.response.status === 400) {
                         this.showNotification('error', error.response.data.msg);
                     } else {
                         console.log(error);
                     }
                 });
        },
        add() {
            this.openModal('new', null);
        },
        edit(criterion) {
            this.openModal('edit', criterion);
        },
        getDetails(criterion) {
            this.openModal('details', criterion);
        },
        openModal(mode, criterion) {
            this.modalMode = mode;
            this.error = false;
            this.errorMessage = '';
            this.criterionEditable.id = criterion ? criterion.id : null;
            this.criterionEditable.name = criterion ? criterion.name : '';
            this.criterionEditable.active = criterion ? criterion.active : false;
            this.criterionEditable.description = criterion ? criterion.description : '';
            $('#modal_dict_criterion').modal('show');
        }

    },
    computed: {
        newCriterionValid() {
            return this.criterionEditable.name !== '';
        }
    },
    created() {
        this.get();
    },
    mounted() {

    }
}
</script>
